import React from "react";
import { Phone } from "lucide-react"; // Using Lucide's Phone icon
import { useNavigate } from "react-router-dom"; // For navigation on button click
import { toast, ToastContainer } from "react-toastify"; // Import react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import the styles for react-toastify

const GetStarted = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    // Show a toast message
    toast.success("Starting your journey with Ryngmo!", {
      position: "top-right",
      autoClose: 3000, // Closes after 3 seconds
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });

    // Navigate to the BusinessName page after a slight delay to allow the toast to be seen
    setTimeout(() => {
      navigate("/business-name"); // Adjust the path as needed
    }, 1000); // Delay of 1 second
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      {/* Main Content */}
      <div className="flex flex-col items-center text-center max-w-lg mx-auto">
        {/* Phone Icon */}
        <div className="mb-6">
          <Phone className="w-12 h-12 text-blue-600" strokeWidth={1.5} />
        </div>

        {/* Heading */}
        <h1 className="md:text-4xl font-bold text-gray-900 mb-4">
          Welcome to Ryngmo
        </h1>

        {/* Subheading */}
        <p className="text-gray-600 text-base md:text-lg mb-8">
          Ryngmo lets you build, test, and scale AI voice agents that answer the phone just like the person
        </p>

        {/* Get Started Button */}
        <button
          onClick={handleGetStarted}
          className="bg-blue-600 text-white font-medium py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Get Started
        </button>
      </div>

      {/* Pagination Dots */}
      <div className="mt-10 flex space-x-2">
        <div className="w-3 h-3 bg-gray-900 rounded-full"></div>
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
      </div>

      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
};

export default GetStarted;